import styled from 'styled-components';
import { FilledInput } from '@material-ui/core';

export const StyledFilledInput = styled(FilledInput)`
  .MuiFilledInput-input {
    padding: 20px;
  }
`;
